import { connect } from "react-redux";
import HierarchyListing from "./HierarchyListing";
import { bindActionCreators } from "redux";
import { financeHierarchyListing, userRequestFilter } from "../../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    helpdeskHierarchyListing : state.UserHelpdesk.helpdeskHierarchyListing,
    filterDetails : state.UserHelpdesk.filterData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        financeHierarchyListing,
        userRequestFilter
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HierarchyListing);